module.exports = __webpack_public_path__ + "static/media/16.e50b3dc5.JPG";